<script setup lang="ts">
import type { HTMLAttributes } from 'vue';
import { ChevronLeft } from 'lucide-vue-next';

withDefaults(
  defineProps<{
    title: string;
    backLabel: string;
    description?: string;
    contentClass?: HTMLAttributes['class'];
    triggerClass?: HTMLAttributes['class'];
  }>(),
  { description: undefined, contentClass: undefined, triggerClass: undefined },
);

const open = defineModel<boolean>('open', { default: false });
</script>

<template>
  <UiSheet v-model:open="open">
    <UiSheetTrigger
      v-if="$slots.trigger"
      :aria-label="title"
      :class="triggerClass"
    >
      <slot name="trigger" />
    </UiSheetTrigger>
    <UiSheetContent
      side="fullscreen"
      hide-close
      class="flex h-full w-full flex-col gap-0 overflow-hidden p-0"
    >
      <div class="flex shrink-0 items-center gap-4 p-4 md:p-6">
        <UiSheetClose as-child>
          <UiButton
            variant="tertiary"
            color="gray"
            size="icon"
            class="shrink-0 text-foreground [&_svg]:size-5"
            :aria-label="backLabel"
          >
            <ChevronLeft
              class="h-5 w-5"
              aria-hidden="true"
            />
          </UiButton>
        </UiSheetClose>
        <UiSheetTitle class="min-w-0 flex-1 truncate text-xl font-semibold text-text-primary-900">
          {{ title }}
        </UiSheetTitle>
        <UiSheetDescription class="sr-only">{{ description ?? title }}</UiSheetDescription>
      </div>
      <div :class="cn('flex min-h-0 flex-1 flex-col overflow-y-auto px-4 pb-4 md:px-6 md:pb-6', contentClass)">
        <slot />
      </div>
      <div
        v-if="$slots.footer"
        class="flex shrink-0 items-center border-t p-4 md:p-6"
      >
        <slot name="footer" />
      </div>
    </UiSheetContent>
  </UiSheet>
</template>
